'use client';

import { Stack } from '@chakra-ui/react';

import type { CurrentCompanyStep } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const CurrentCompany = () => {
	return (
		<Stack gap="md">
			<Form.TextInput<CurrentCompanyStep>
				label="Current Company"
				name="companyName"
			/>
			<Form.Checkbox<CurrentCompanyStep>
				label="Do you want to hide your current company name from public?"
				name="hideCompanyName"
			>
				Hide
			</Form.Checkbox>
		</Stack>
	);
};
